$(document).ready(function(){

   $('body').on('click', '.qtyplusdrawer', function(e) {
   e.preventDefault();
 var valuepluss = $(this).attr("max");
     
     var val_qty = parseInt($(this).prev(".qty").val());
  if(val_qty >= 0 &&  val_qty < valuepluss)
  {
        val_qty = val_qty + 1 ;
  }
//$(this).parents(".customMobile").prev(".customDesktop").children(".CstomQuantDrawer").val(val_qty).trigger("change");
    $(this).prev(".CstomQuantDrawer").val(val_qty).trigger("change");

    });
  $('body').on('click', '.qtyminusdrawer', function(e) {
      e.preventDefault();
 var valueplus = $(this).attr("min");
     
     var val_qty = parseInt($(this).next(".qty").val());
  if(val_qty > 1)
  {
        val_qty = val_qty - 1 ;
  }

    $(this).next(".CstomQuantDrawer").val(val_qty).trigger("change");
//$(this).parents(".customMobile").prev(".customDesktop").children(".CstomQuantDrawer").val(val_qty).trigger("change");
    });
 $('.qtyplus').click(function(e){
   e.preventDefault();
 var valuepluss = $(this).attr("max");
     
     var val_qty = parseInt($(this).prev(".qty").val());
  if(val_qty >= 0 &&  val_qty < valuepluss)
  {
        val_qty = val_qty + 1 ;
  }
$(this).parents(".qty-group").children(".CstomQuant").val(val_qty).trigger("change");
    $(this).prev(".qty").val(val_qty);

    });
  $('.qtyminus').click(function(e){
      e.preventDefault();
 var valueplus = $(this).attr("min");
     
     var val_qty = parseInt($(this).next(".qty").val());
  if(val_qty > 1)
  {
        val_qty = val_qty - 1 ;
  }

    $(this).next(".qty").val(val_qty);
$(this).parents(".qty-group").children(".CstomQuant").val(val_qty).trigger("change");
    });

 var slideWrapper = $(".product-photo-container"),
    iframes = slideWrapper.find('.embed-player'),
    lazyImages = slideWrapper.find('.slide-image'),
    lazyCounter = 0;

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command){
  // console.log(command);
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

// When the slide is changing
function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.find('iframe').data('type');
  player = currentSlide.find("iframe").get(0);
  //startTime = currentSlide.data("video-start");

  if (slideType === "vimeo") {
    switch (control) {
      case "play":
        if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
          currentSlide.addClass('started');
          postMessageToPlayer(player, {
            "method": "setCurrentTime",
            "value" : startTime
          });
        }
        postMessageToPlayer(player, {
          "method": "play",
          "value" : 1
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "method": "pause",
          "value": 1
        });
        break;
    }
  } else if (slideType === "youtube") {
    
    switch (control) {
      case "play":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "mute"
        });
        postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  } else if (slideType === "video") {
    video = currentSlide.children("video").get(0);
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }
  }
}

// Resize player
function resizePlayer(iframes, ratio) {
  if (!iframes[0]) return;
  var win = $(".main-slider"),
      width = win.width(),
      playerWidth,
      height = win.height(),
      playerHeight,
      ratio = ratio || 16/9;

  iframes.each(function(){
    var current = $(this);
    if (width / ratio < height) {
      playerWidth = Math.ceil(height * ratio);
      current.width(playerWidth).height(height).css({
        left: (width - playerWidth) / 2,
         top: 0
        });
    } else {
      playerHeight = Math.ceil(width / ratio);
      current.width(width).height(playerHeight).css({
        left: 0,
        top: (height - playerHeight) / 2
      });
    }
  });
}

// DOM Ready
$(function() {
  // Initialize
  slideWrapper.on("init", function(slick){
    slick = $(slick.currentTarget);
    setTimeout(function(){
      playPauseVideo(slick,"play");
    }, 1000);
    
    //resizePlayer(iframes, 16/9);
  });
  slideWrapper.on("beforeChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
  });
  slideWrapper.on("afterChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"play");
  });
  slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
    lazyCounter++;
    if (lazyCounter === lazyImages.length){
      lazyImages.addClass('show');
      // slideWrapper.slick("slickPlay");
    }
  });

  //start the slider
//   slideWrapper.slick({
//     // fade:true,
//     autoplaySpeed:4000,
//     lazyLoad:"progressive",
//     speed:600,
//     arrows:false,
//     dots:true,
//     cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
//   });
});

// Resize event
$(window).on("resize.slickVideoPlayer", function(){  
  resizePlayer(iframes, 16/9);
});
});



$(document).ready(function() {
    
	
  $('.tabs a').click(function(){
     $('.panel').hide();
     $('.tabs a.active').removeClass('active');
     $(this).addClass('active');
     
     var panel = $(this).attr('href');
     
     $(panel).fadeIn(1000);
     return false; 
    
  });  

  if($('.help-center').length > 0){
    var pagehandle = $('.help-center').attr('data-page-handle');
    if(pagehandle == 'warranty'){
      $('.help-center-left .tabs li a[href="#panel3"]').click();
    } else if(pagehandle == 'commercial-sales'){
       $('.help-center-left .tabs li a[href="#panel5"]').click();
    } else if(pagehandle == 'returns'){
       $('.help-center-left .tabs li a[href="#panel2"]').click();
    } else if(pagehandle == 'contact-us'){
       $('.help-center-left .tabs li a[href="#panel6"]').click();
    } else if(pagehandle == 'warranty-claim'){
       $('.help-center-left .tabs li a[href="#panel4"]').click();
    } else if(pagehandle == 'lighting-facts-label'){
      $('.help-center-left .tabs li a[href="#panel2"]').click();
    } else if(pagehandle == 'manuals-downloads'){
      $('.help-center-left .tabs li a[href="#panel3"]').click();
    } else if(pagehandle == 'cec-title-20-and-title-24-efficiency-regulations'){
      $('.help-center-left .tabs li a[href="#panel5"]').click();
    } else if(pagehandle == 'certifications'){
      $('.help-center-left .tabs li a[href="#panel4"]').click();
    } else if(pagehandle == 'resources'){
      $('.help-center-left .tabs li a[href="#panel1"]').click();
    }  else if(pagehandle == 'help-center'){
      $('.help-center-left .tabs li a[href="#panel1"]').click();
    }
  }
});



$(document).ready(function() {
  $(".set > a").on("click", function(e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });

  $(".sub-head").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".sub-cont")
        .slideUp(200);
      $(".sub-head i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".sub-head i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".sub-head").removeClass("active");
      $(this).addClass("active");
      $(".sub-cont").slideUp(200);
      $(this)
        .siblings(".sub-cont")
        .slideDown(200);
    }
  });
  
  $('.sub-tab a').click(function(){
  
     $('.docs-manuals').hide();
     $('.sub-tab a.active').removeClass('active');
     $(this).addClass('active');
     
     var tabs = $(this).attr('href');
     
     $(tabs).fadeIn(1000);
     return false; 
    
  });  
	
  $('.sub-tab li:first a').trigger('click');

});
$(window).load(function(){
  $('.sub-cont').css('display','none');
});

$(document).ready(function () {

  $(function(){
    /**
     * myAccordion function
     */

    $("#accordions .accordion-header").on("click",function(){
      var indis = $(this).index();
      $(this).toggleClass("toggle-header")
      $("#accordions ul li .accordion-body").stop().slideUp();
      $(this).next(".accordion-body").stop().slideToggle();
    });

  });  
  
  $("#faq_search").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $(".docs-manuals .set").filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
  });
  
  $('.footer-bottom a.dontdoIt').click(function(event) {
    event.preventDefault()
    alertify.alert('Sunco Lighting','  Sunco does <u>not</u> sell Personal Information. We never have. We never will.<br><br>A new California law requires the option for consumers to opt out of selling Personal Information, among other things. If you are a California resident, please <a href="https://www.suncolighting.com/pages/california-privacy-notice" title="California Privacy Notice">click here</a> to continue and learn more about the California Consumer Privacy Acct CCPA or <a href="https://www.suncolighting.com/pages/sunco-lighting-opt-out-form" title="Opt Out Form">continue to opt out form</a>.').show();
  });
 
});